// extracted by mini-css-extract-plugin
export default {"searchBoxContainer":"search-box_searchBoxContainer__PIORm","searchBar":"search-box_searchBar__49a1y","customInput":"search-box_customInput__zaXN2"};